import * as React from "react";
import { TeamGenerator } from "../../components/index/TeamGenerator";
import { SoloGenerator } from "../../components/index/SoloGenerator";


export enum AppMode {
  solo,
  team,
}

export interface AppProps {
}


export interface AppState {
  mode: AppMode;
}


export class App extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);

    this.state = {
      mode: AppMode.team,
    };
  }


  componentDidMount(): void {
  }

  render() {
    return (
      <div>
        <form>
          <div className="form-group row">
            <label htmlFor="mode-selector" className="col-sm-2 col-form-label">
              モード
            </label>
            <div className="col-sm-10">
              <select id="mode-selector" className="form-control"
                      value={this.state.mode}
                      onChange={e => {
                        const mode = parseInt(e.target.value) as AppMode;

                        this.setState({
                          mode,
                        });
                      }}>
                <option value={AppMode.solo}>
                  1人プレイ
                </option>
                <option value={AppMode.team}>
                  2人チームプレイ
                </option>
              </select>
            </div>
          </div>
        </form>

        {(() => {
          switch (this.state.mode) {
            case AppMode.team:
              return (
                <TeamGenerator/>
              );
            case AppMode.solo:
              return (
                <SoloGenerator/>
              );
            default:
              return (
                <div>
                  未実装
                </div>
              );
          }
        })()}

      </div>
    );
  }
}
